@if (!isCardListStyle && !displayIncrementer) {
  <button type="button" class="cfa-plain-button" (click)="cardClicked()">
    <mat-card
      class="reward-card__card"
      [attr.data-testid]="name + 'reward-card'">
      <ng-container *ngTemplateOutlet="rewardCardBody"></ng-container>
    </mat-card>
  </button>
}
@if (!isCardListStyle && displayIncrementer) {
  <mat-card
    class="reward-card__card"
    [ngClass]="{'reward-card__selected-reward': numberSelected > 0, 'reward-card__disabled-select': disableIncrement}"
    [attr.data-testid]="name + 'reward-card'"
    (click)="cardClicked()"
    (keydown.enter)="$event.target === $event.currentTarget && (cardClicked())">
    <ng-container *ngTemplateOutlet="rewardCardBody"></ng-container>
  </mat-card>
}
<ng-template #rewardCardBody>
  <div fxLayout="column"
    fxLayoutAlign="space-between center"
    [ngClass]="{'reward-card__main-container': !displayIncrementer, 'reward-card__main-container-resize': displayIncrementer}">
    <div [ngClass]="{'reward-card__image-container': !displayIncrementer, 'reward-card__image-container-resize': displayIncrementer}"
      fxLayout="column"
      fxLayoutAlign="center center">
      <img [src]="imageUrl" class="reward-card__image" alt="">
    </div>
    <div [ngClass]="{'reward-card__text-container' :!endDateRestriction, 'reward-card__text-contanier-lto': endDateRestriction }"
      [attr.data-testid]="name + 'reward-name'"
      fxLayout="column"
      fxLayoutAlign="space-evenly center">
      <div class="reward-card__title"
        [ngStyle]="{'font-size': fontSize}">
        {{name}}
      </div>
    </div>
    @if (endDateRestriction) {
      <div
        class = "reward-card__limited-time-offer-text"
        fxLayout="column"
        fxLayoutAlign="centercenter">
        <div class="reward-card__text">Limited time offer only!</div>
        <div  class="reward-card__subtext">Valid Until {{endDateRestriction | myDate : 'MMM DD, YYYY'}}</div>
      </div>
    }
    @if (displayIncrementer) {
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="reward-card__stepper-container">
        <increment-stepper [numberSelected]="numberSelected"
          [disableDecrement]="numberSelected === 0"
          [disableIncrement]="disableIncrement"
          [isRedTheme]=true
          (decrementSelected)="decremented.emit()"
          (incrementSelected)="incremented.emit()">
        </increment-stepper>
      </div>
    }
  </div>
</ng-template>
@if (isCardListStyle) {
  <button type="button" class="cfa-plain-button" (click)="cardClicked()">
  <mat-card class="reward-card__card">
    <div fxLayout="row" fxLayoutAlign="start center" class="reward-card__mb-container">
      <div class="reward-card__image-mb-container" fxLayout="column" fxLayoutAlign="center center">
        <img [src]="imageUrl" class="reward-card__image-mb" alt="">
      </div>
      <div class="reward-card__item-name-mb-wrapper" fxLayout="column" fxLayoutAlign="center start">
        <p class="reward-card__item-name-mb" [attr.data-testid]="name + 'reward-name'">
          {{name}}
        </p>
      </div>
    </div>
  </mat-card>
  </button>
}
